import { EditBase, Form } from "ra-core";
import { Card, CardContent } from "@/components/ui/card";
import { DeleteButton } from "@/components/admin/delete-button";

import { FormToolbar } from "../layout/FormToolbar";
import { LeadInputs } from "./LeadInputs";
import { cleanupLeadForSave } from "./leadModel";

export const LeadEdit = () => {
  return (
    <EditBase redirect="show" transform={cleanupLeadForSave}>
      <div className="mt-2 mb-12 flex flex-col gap-4 w-full">
        <div className="flex justify-between items-center">
          <h1 className="text-2xl font-bold">Edit Lead</h1>
          <DeleteButton
            redirect="list"
            confirm
            confirmTitle="Delete this lead?"
            confirmContent="This lead will be permanently deleted."
          />
        </div>
        <Form>
          <Card>
            <CardContent className="pt-6">
              <LeadInputs />
              <FormToolbar />
            </CardContent>
          </Card>
        </Form>
      </div>
    </EditBase>
  );
};
